import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getVRApuracoes, getVRApuracao, deleteVRApuracao, getDepartamentos } from '../services/api';
import jsPDF from 'jspdf';

const MESES_PT = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
const fmtMes = (m, a) => m && a ? `${MESES_PT[m-1]}/${a}` : '—';
const fmtNum = n => n == null ? '—' : (Number(n) % 1 === 0 ? String(Number(n)) : Number(n).toFixed(1));

function exportarPDF(vr) {
  const labelCred = fmtMes(vr.mes_cred, vr.ano_cred);
  const labelRef  = fmtMes(vr.mes_ref,  vr.ano_ref);
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const pw = doc.internal.pageSize.getWidth();
  const ML = 14, MR = 14;

  doc.setFontSize(13); doc.setTextColor(79, 70, 229);
  doc.text(`Apuração de VR — Competência ${labelCred}`, ML, 16);
  doc.setFontSize(8.5); doc.setTextColor(100, 116, 139);
  doc.text(`Mês Atual: ${labelRef}  ·  Status: ${vr.status}  ·  Gerado em ${new Date().toLocaleDateString('pt-BR')}`, ML, 22);
  doc.setDrawColor(226, 232, 240); doc.setLineWidth(0.3); doc.line(ML, 25, pw - MR, 25);

  const cols = [
    { label: 'Funcionário', w: 62 }, { label: 'Dias Úteis', w: 18 },
    { label: 'Férias/Afastam.', w: 22 }, { label: 'Base VR', w: 18 },
    { label: 'Faltas', w: 16 }, { label: 'F.Just.<6h', w: 18 },
    { label: 'Extras', w: 16 }, { label: 'Total VR', w: 18 },
  ];
  const totalW = cols.reduce((s, c) => s + c.w, 0);
  let y = 30; const rowH = 7; let cx = ML;

  doc.setFillColor(26, 46, 74); doc.rect(ML, y, totalW, rowH, 'F');
  doc.setFontSize(7); doc.setTextColor(147, 197, 253); doc.setFont('helvetica', 'bold');
  cols.forEach(c => { doc.text(c.label, cx + c.w/2, y + 4.5, { align: 'center' }); cx += c.w; });
  y += rowH;

  doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5);
  vr.itens.forEach((item, idx) => {
    if (idx % 2 === 1) { doc.setFillColor(248, 250, 252); doc.rect(ML, y, totalW, rowH, 'F'); }
    doc.setTextColor(30, 41, 59);
    const vals = [
      item.nome, String(item.diasUteis),
      item.diasSemDireito > 0 ? String(item.diasSemDireito) : '—',
      String(item.vrBase),
      item.faltas > 0 ? String(item.faltas) : '—',
      item.faltasJust > 0 ? fmtNum(item.faltasJust) : '—',
      (item.extrasInteiro + item.extrasMeio * 0.5) > 0 ? `+${fmtNum(item.extrasInteiro + item.extrasMeio * 0.5)}` : '—',
      fmtNum(Number(item.total)),
    ];
    cx = ML;
    vals.forEach((v, vi) => {
      const align = vi === 0 ? 'left' : 'center';
      const x2 = vi === 0 ? cx + 2 : cx + cols[vi].w/2;
      if (vi === vals.length - 1) { doc.setTextColor(79, 70, 229); doc.setFont('helvetica', 'bold'); }
      doc.text(v, x2, y + 4.5, { align });
      doc.setTextColor(30, 41, 59); doc.setFont('helvetica', 'normal');
      cx += cols[vi].w;
    });
    doc.setDrawColor(226, 232, 240); doc.setLineWidth(0.2); doc.line(ML, y + rowH, ML + totalW, y + rowH);
    y += rowH;
  });

  const tot = vr.itens.reduce((acc, x) => ({
    diasUteis: acc.diasUteis + x.diasUteis, diasSemDireito: acc.diasSemDireito + x.diasSemDireito,
    vrBase: acc.vrBase + x.vrBase, faltas: acc.faltas + x.faltas,
    faltasJust: acc.faltasJust + x.faltasJust,
    extrasInteiro: acc.extrasInteiro + x.extrasInteiro, extrasMeio: acc.extrasMeio + x.extrasMeio,
    total: acc.total + Number(x.total),
  }), { diasUteis:0,diasSemDireito:0,vrBase:0,faltas:0,faltasJust:0,extrasInteiro:0,extrasMeio:0,total:0 });

  doc.setFillColor(239, 246, 255); doc.rect(ML, y, totalW, rowH, 'F');
  doc.setFont('helvetica', 'bold'); doc.setFontSize(7.5);
  const totVals = [
    `${vr.itens.length} func.`, String(tot.diasUteis),
    tot.diasSemDireito > 0 ? String(tot.diasSemDireito) : '—', String(tot.vrBase),
    tot.faltas > 0 ? `−${tot.faltas}` : '—',
    tot.faltasJust > 0 ? `−${fmtNum(tot.faltasJust * 0.5)}` : '—',
    (tot.extrasInteiro + tot.extrasMeio * 0.5) > 0 ? `+${fmtNum(tot.extrasInteiro + tot.extrasMeio * 0.5)}` : '—',
    fmtNum(tot.total),
  ];
  cx = ML;
  totVals.forEach((v, vi) => {
    if (vi === totVals.length - 1) doc.setTextColor(79, 70, 229); else doc.setTextColor(30, 41, 59);
    const align = vi === 0 ? 'left' : 'center';
    doc.text(v, vi === 0 ? cx + 2 : cx + cols[vi].w/2, y + 4.5, { align });
    cx += cols[vi].w;
  });

  doc.save(`VR_${labelCred.replace('/', '-')}.pdf`);
}

function getNextMonth() {
  const hoje = new Date();
  let m = hoje.getMonth() + 2;
  let a = hoje.getFullYear();
  if (m > 12) { m = 1; a += 1; }
  return { mes: m, ano: a };
}

export default function RelatorioVR() {
  const navigate = useNavigate();
  const [vrs, setVrs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroDep, setFiltroDep] = useState('');

  // Modal "Criar VR"
  const def = getNextMonth();
  const [showModal, setShowModal] = useState(false);
  const [novoMes, setNovoMes] = useState(def.mes);
  const [novoAno, setNovoAno] = useState(def.ano);
  const [novoDep, setNovoDep] = useState('');

  const anoAtual = new Date().getFullYear();
  const anos = [];
  for (let y = anoAtual - 2; y <= anoAtual + 2; y++) anos.push(y);
  const meses = [
    {v:1,l:'Janeiro'},{v:2,l:'Fevereiro'},{v:3,l:'Março'},{v:4,l:'Abril'},
    {v:5,l:'Maio'},{v:6,l:'Junho'},{v:7,l:'Julho'},{v:8,l:'Agosto'},
    {v:9,l:'Setembro'},{v:10,l:'Outubro'},{v:11,l:'Novembro'},{v:12,l:'Dezembro'},
  ];

  const handleIrApuracao = () => {
    setShowModal(false);
    navigate('/vr-apuracao', { state: { mes: novoMes, ano: novoAno, departamento: novoDep || null } });
  };

  // Exclusão
  const [vrParaDeletar, setVrParaDeletar] = useState(null);
  const [deletando, setDeletando] = useState(false);

  const handleDeletar = async () => {
    if (!vrParaDeletar) return;
    setDeletando(true);
    try {
      await deleteVRApuracao(vrParaDeletar.id);
      setVrParaDeletar(null);
      carregar();
    } catch { /* silencioso */ } finally { setDeletando(false); }
  };

  // PDF direto da lista
  const [gerandoPdf, setGerandoPdf] = useState(null);

  const handlePDF = async (id) => {
    setGerandoPdf(id);
    try {
      const r = await getVRApuracao(id);
      exportarPDF(r.data);
    } catch { /* silencioso */ } finally { setGerandoPdf(null); }
  };

  useEffect(() => {
    getDepartamentos({ ativo: true })
      .then(r => setDepartamentos(r.data.results || r.data))
      .catch(() => {});
  }, []);

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filtroStatus) params.status = filtroStatus;
      if (filtroDep) params.departamento = filtroDep;
      const r = await getVRApuracoes(params);
      setVrs(r.data.results || r.data);
    } catch { setVrs([]); } finally { setLoading(false); }
  }, [filtroStatus, filtroDep]);

  useEffect(() => { carregar(); }, [carregar]);

  return (
    <div>
      {/* Cabeçalho */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingBottom:16, marginBottom:20, borderBottom:'1px solid #f1f5f9' }}>
        <div style={{ display:'flex', alignItems:'center' }}>
          <div style={{ width:38, height:38, background:'#faf5ff', border:'1px solid #d8b4fe', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', color:'#7c3aed', fontSize:'1rem', marginRight:14, flexShrink:0 }}>
            <i className="bi bi-receipt-cutoff" />
          </div>
          <div>
            <div style={{ fontSize:'var(--fs-2xs)', fontWeight:600, color:'var(--text-subtle)', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:3 }}>Gestão de Pessoal · Controle de Ponto</div>
            <div style={{ fontSize:'1.3rem', fontWeight:700, color:'#334155', letterSpacing:'-0.5px', lineHeight:1.2 }}>Relatório de VR</div>
          </div>
        </div>
        <button
          className="btn-primary-custom"
          onClick={() => setShowModal(true)}
          style={{ background:'linear-gradient(135deg,#7c3aed,#6d28d9)', boxShadow:'0 4px 14px rgba(124,58,237,0.3)' }}
        >
          <i className="bi bi-plus-lg" /> Criar VR
        </button>
      </div>

      {/* Modal Criar VR */}
      {showModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.45)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 20px 60px rgba(15,23,42,0.2)', padding:28, minWidth:360, maxWidth:440, width:'100%' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <div style={{ width:34, height:34, background:'#faf5ff', border:'1px solid #d8b4fe', borderRadius:9, display:'flex', alignItems:'center', justifyContent:'center', color:'#7c3aed', fontSize:'1rem' }}>
                  <i className="bi bi-calculator-fill" />
                </div>
                <div>
                  <div style={{ fontWeight:700, fontSize:'var(--fs-base)', color:'#1e293b' }}>Nova Apuração de VR</div>
                  <div style={{ fontSize:'var(--fs-2xs)', color:'var(--text-muted)' }}>Selecione o período de competência</div>
                </div>
              </div>
              <button className="btn-icon" onClick={() => setShowModal(false)} style={{ color:'var(--text-muted)' }}>
                <i className="bi bi-x-lg" />
              </button>
            </div>

            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div>
                <label className="form-label" style={{ marginBottom:4, fontWeight:600 }}>Mês de Competência</label>
                <div style={{ display:'flex', gap:8 }}>
                  <select className="form-select" value={novoMes} onChange={e => setNovoMes(Number(e.target.value))} style={{ flex:1 }}>
                    {meses.map(m => <option key={m.v} value={m.v}>{m.l}</option>)}
                  </select>
                  <select className="form-select" value={novoAno} onChange={e => setNovoAno(Number(e.target.value))} style={{ width:90 }}>
                    {anos.map(y => <option key={y} value={y}>{y}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <label className="form-label" style={{ marginBottom:4, fontWeight:600 }}>Departamento <span style={{ fontWeight:400, color:'var(--text-muted)' }}>(opcional)</span></label>
                <select className="form-select" value={novoDep} onChange={e => setNovoDep(e.target.value)}>
                  <option value="">Todos</option>
                  {departamentos.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}
                </select>
              </div>
            </div>

            <div style={{ display:'flex', justifyContent:'flex-end', gap:8, marginTop:22 }}>
              <button className="btn-secondary-custom" onClick={() => setShowModal(false)}>Cancelar</button>
              <button
                className="btn-primary-custom"
                onClick={handleIrApuracao}
                style={{ background:'linear-gradient(135deg,#7c3aed,#6d28d9)', boxShadow:'0 4px 14px rgba(124,58,237,0.3)' }}
              >
                <i className="bi bi-arrow-right" /> Ir para Apuração
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="filter-bar">
        <div>
          <label className="form-label">Status</label>
          <select className="form-select" style={{ width:140 }} value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
            <option value="">Todos</option>
            <option value="ABERTO">Aberto</option>
            <option value="FECHADO">Fechado</option>
          </select>
        </div>
        <div>
          <label className="form-label">Departamento</label>
          <select className="form-select" style={{ width:180 }} value={filtroDep} onChange={e => setFiltroDep(e.target.value)}>
            <option value="">Todos</option>
            {departamentos.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}
          </select>
        </div>
        <div style={{ alignSelf:'flex-end' }}>
          <button className="btn-secondary-custom" onClick={carregar}>
            <i className="bi bi-arrow-clockwise" /> Atualizar
          </button>
        </div>
      </div>

      {/* Tabela */}
      {loading ? (
        <div style={{ display:'flex', justifyContent:'center', padding:'40px 0', color:'var(--text-muted)' }}>
          <span className="spinner-border spinner-border-sm me-2" />Carregando...
        </div>
      ) : vrs.length === 0 ? (
        <div className="empty-state">
          <i className="bi bi-receipt-cutoff" />
          <p>Nenhum VR encontrado. Clique em <strong>Criar VR</strong> para iniciar uma nova apuração.</p>
        </div>
      ) : (
        <div className="card-ponto p-0">
          <table className="table-ponto" style={{ width:'100%' }}>
            <thead>
              <tr>
                <th style={{ paddingLeft:20 }}>#</th>
                <th>Competência</th>
                <th>Mês Atual</th>
                <th>Departamento</th>
                <th style={{ textAlign:'center' }}>Funcionários</th>
                <th style={{ textAlign:'center' }}>Total Tickets</th>
                <th style={{ textAlign:'center' }}>Status</th>
                <th>Criado em</th>
                <th style={{ textAlign:'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {vrs.map((vr, i) => (
                <tr key={vr.id} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <td style={{ paddingLeft:20, color:'var(--text-muted)', fontWeight:500 }}>#{vr.id}</td>
                  <td style={{ fontWeight:700, color:'#4f46e5' }}>{fmtMes(vr.mes_cred, vr.ano_cred)}</td>
                  <td style={{ color:'var(--text-secondary)' }}>{fmtMes(vr.mes_ref, vr.ano_ref)}</td>
                  <td style={{ color:'var(--text-muted)' }}>{vr.departamento_nome || <span style={{ color:'var(--text-subtle)' }}>Todos</span>}</td>
                  <td style={{ textAlign:'center' }}>{vr.total_funcionarios}</td>
                  <td style={{ textAlign:'center', fontWeight:700, color:'#4f46e5' }}>{fmtNum(vr.total_tickets)}</td>
                  <td style={{ textAlign:'center' }}>
                    {vr.status === 'FECHADO'
                      ? <span style={{ background:'#f0fdf4', color:'#15803d', border:'1px solid #bbf7d0', borderRadius:999, padding:'2px 10px', fontSize:'var(--fs-2xs)', fontWeight:700, textTransform:'uppercase' }}>Fechado</span>
                      : <span style={{ background:'#eff6ff', color:'#1d4ed8', border:'1px solid #bfdbfe', borderRadius:999, padding:'2px 10px', fontSize:'var(--fs-2xs)', fontWeight:700, textTransform:'uppercase' }}>Aberto</span>
                    }
                  </td>
                  <td style={{ color:'var(--text-muted)', whiteSpace:'nowrap' }}>{vr.criado_em_fmt}</td>
                  <td style={{ textAlign:'center' }}>
                    <div style={{ display:'inline-flex', gap:4 }}>
                      <button className="btn-icon" style={{ color:'#7c3aed' }} title="Consultar" onClick={() => navigate(`/relatorio-vr/${vr.id}`)}>
                        <i className="bi bi-eye" />
                      </button>
                      <button className="btn-icon" style={{ color:'#15803d' }} title="Exportar PDF"
                        onClick={() => handlePDF(vr.id)} disabled={gerandoPdf === vr.id}>
                        {gerandoPdf === vr.id
                          ? <span className="spinner-border spinner-border-sm" style={{ width:12, height:12 }} />
                          : <i className="bi bi-file-earmark-pdf" />}
                      </button>
                      <button className="btn-icon" style={{ color:'#dc2626' }} title="Deletar"
                        onClick={() => setVrParaDeletar(vr)}>
                        <i className="bi bi-trash3" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal Confirmar Exclusão */}
      {vrParaDeletar && (
        <div style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.45)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={e => e.target === e.currentTarget && setVrParaDeletar(null)}>
          <div style={{ background:'#fff', borderRadius:14, boxShadow:'0 20px 60px rgba(15,23,42,0.2)', padding:28, minWidth:360, maxWidth:420, width:'100%' }}>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16 }}>
              <div style={{ width:36, height:36, background:'#fef2f2', border:'1px solid #fecaca', borderRadius:9, display:'flex', alignItems:'center', justifyContent:'center', color:'#dc2626', fontSize:'1rem', flexShrink:0 }}>
                <i className="bi bi-trash3-fill" />
              </div>
              <div>
                <div style={{ fontWeight:700, fontSize:'var(--fs-base)', color:'#1e293b' }}>Confirmar exclusão</div>
                <div style={{ fontSize:'var(--fs-2xs)', color:'var(--text-muted)' }}>Esta ação não pode ser desfeita.</div>
              </div>
            </div>
            <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:'10px 14px', marginBottom:20, fontSize:'var(--fs-xs)', color:'#7f1d1d' }}>
              <strong>VR #{vrParaDeletar.id}</strong> — Competência {fmtMes(vrParaDeletar.mes_cred, vrParaDeletar.ano_cred)}
              {vrParaDeletar.departamento_nome && <> · {vrParaDeletar.departamento_nome}</>}
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:8 }}>
              <button className="btn-secondary-custom" onClick={() => setVrParaDeletar(null)} disabled={deletando}>Cancelar</button>
              <button className="btn-danger-custom" onClick={handleDeletar} disabled={deletando}>
                {deletando ? <><span className="spinner-border spinner-border-sm" style={{ width:10, height:10 }} />Deletando...</> : <><i className="bi bi-trash3" />Deletar</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
